const step = (title, content) => ({ title, content });
const doc = (name, summary, flow, steps, reminders = [], sections = []) => ({ name, summary, flow, steps, reminders, sections });

const documents = {
  "gold-management": doc(
    "金料管理",
    "业务申请分为“汇总销售补料”和“提交供应商结算需求”两种方式，请按实际业务选择对应流程。",
    [],
    [],
    ["未匹配销售部门的出退库不会进入本次需求，但不会阻断其他有效数据。", "销售补料申请量超过系统非负建议量时，必须填写超额原因并等待特批。", "供应商结算需求必须关联未结欠料或货品采购明细，同一业务来源不能重复提报。"],
    [
      {
        title: "页签一：库存工作台",
        content: "查看公司总库和部门库的实物、占用、可用、库存值以及已付款在途。顶部汇总卡可点击查看组成明细。",
        flow: ["选择公司", "启用账户", "核对库存", "查看在途", "必要时实盘调整"],
        steps: [
          step("先维护账户", "部门和材质组合必须存在已启用账户，采购收货才能自动分配；账户缺失或停用时，分配页面会显示明确提示。"),
          step("核对汇总", "实物库存等于账户账面克重，可用库存等于实物减占用；在途仅统计付款流程已完成且尚未收货或短收关闭的采购量。")
        ]
      },
      {
        title: "页签二：需求与定额",
        content: "办理销售补料和供应商结算需求，并按状态进入财务定额、超额特批、采购定价或后续执行。",
        flow: ["新建需求", "财务定额", "超额特批（如有）", "采购定价或调拨", "执行完成"]
      },
      {
        title: "页签三：采购与回货",
        content: "跟踪外采金料的付款、在途、分批收货、部门分配和短收关闭。",
        flow: ["整单定价并关联付款", "登记收货", "匹配申请部门账户", "确认分配", "完成或短收关闭"],
        steps: [
          step("登记收货", "按实际到货克重登记，可分多个收货批次；累计收货和短收关闭量不能超过采购量。"),
          step("自动分配归属", "系统从收货批次回溯原需求，自动使用同公司、申请部门和材质的已启用账户，不允许改分到其他部门。")
        ]
      },
      {
        title: "页签四：内部调拨",
        content: "处理财务定额拆分出的公司总库至需求部门调拨。",
        flow: ["生成调拨单", "实物交接", "确认交接", "总库扣减并入部门库"]
      },
      {
        title: "页签五：供应商结余/欠料",
        content: "按供应商、部门和材质跟踪欠料与结余；备料进入部门库后仍需单独确认送厂还料。",
        flow: ["形成欠料", "查看未结头寸", "部门备料", "送厂还料", "结清或形成结余"]
      },
      {
        title: "页签六：成本修正",
        content: "处理欠料预估价与实际还料价产生的成本差异。",
        flow: ["生成成本差异", "选择会计月份", "导出月报", "财务调账", "登记凭证"],
        steps: [step("完成闭环", "同月且货品仍在库的差异直接修正当前成本；跨月或已出库差异需导出后人工调账并登记凭证号。")]
      },
      {
        title: "方式一：汇总销售补料",
        content: "适用于根据正式销售出库和有效退货，按部门自动计算补料金重。",
        flow: ["选择公司", "新建销售补料", "设置范围和材质", "汇总正式出退库", "核对申请克重", "保存并提交"],
        steps: [
          step("进入申请", "选择公司，进入“需求与定额”页签，点击“新建销售补料”。首次汇总默认统计最近 24 小时，后续默认从上次成功提交的截止时间开始。"),
          step("汇总正式出退库", "选择统计范围和金料材质后点击“汇总正式出退库”。正式出退库中 GoldWeight 大于 0 的记录按所选材质汇总，并按销售部门、渠道生成系统净建议。"),
          step("处理异常提示", "未匹配销售部门的记录会提示数量并自动跳过，请检查销售订单的部门配置；其他已匹配记录仍可继续办理。"),
          step("确认并提交", "逐行核对系统净建议和申请克重。申请量超过系统非负建议量时填写超额原因，确认后点击“保存并提交”，需求进入待财务定额。")
        ]
      },
      {
        title: "方式二：提交需求（供应商结算）",
        content: "适用于部门需要采购金料，以归还供应商欠料或结算指定货品采购明细。",
        flow: ["选择公司", "新建供应商结算需求", "填写结算信息", "关联欠料或采购明细", "核对应结克重", "保存并提交"],
        steps: [
          step("进入申请", "选择公司，进入“需求与定额”页签，点击“新建供应商结算需求”。"),
          step("填写结算信息", "选择部门、已启用供应商和金料材质，并填写大于 0 的应结克重。供应商编号和名称均取自采购供应商配置。"),
          step("关联业务来源", "选择“关联欠料”或“关联采购明细”，按单号、商品或供应商搜索并从分页列表选择，系统回填并锁定供应商、部门、材质及可申请克重。采购明细已生成欠料时，请切换为关联欠料；同一来源不能重复提报。"),
          step("确认并提交", "应结克重不得超过所选欠料的未结克重。核对无误后点击“保存并提交”，需求进入待财务定额。")
        ]
      },
      {
        title: "两种申请提交后的共同处理",
        flow: ["财务定额", "超额特批（如有）", "内部调拨或外采", "付款与收货", "分配部门账户", "还料或完成"],
        steps: [
          step("财务定额", "财务逐行确认批准量，并拆分公司总库内部调拨量和外部采购量；两者合计必须等于批准量。"),
          step("执行调拨或采购", "内部调拨由供应链确认实物交接；外采在需求操作列点击“金料定价”，统一录入供应商、实际金价并关联一张未绑定的采购付款请款单。其他状态保留相同字段供只读查看。"),
          step("核对付款差异", "定价会记录采购总额与请款单合计的差异并提示核对；付款单成功关联后即可收货或短收关闭，付款审批状态和金额差异不再阻断实物操作。"),
          step("收货和后续处理", "“执行中”按待办提供查看付款、收货、分配和调拨交接入口。付款审批与实物执行独立，关联付款单后即可登记收货，分配后才增加部门库存；调拨交接与全部采购分配完成后需求自动完成。供应商结算仍需继续送厂还料，需求完成不代表欠料已结清。")
        ]
      }
    ]
  ),
  application: doc(
    "库存管理入口",
    "集中进入库存单据、库存查询、统计报表和货品基础资料页面。",
    ["选择业务分类", "进入目标页面", "按权限查询或操作"],
    [
      step("选择业务区域", "库存单据用于办理出入库和盘点，库存查询用于查看结余及流水，统计报表用于分析数据，基础资料用于维护 SPU、SKU。"),
      step("进入业务页面", "点击业务卡片进入对应列表或表单，再根据页面帮助完成具体操作。")
    ],
    ["菜单和按钮会随账号权限变化。", "入口页只负责导航，不会直接修改库存。"]
  ),
  "spu-list": doc(
    "SPU 管理",
    "维护一组 SKU 共用的商品主信息、分类、品牌、工厂、规格和图片。",
    ["查询 SPU", "新增或编辑", "维护分类和规格", "保存"],
    [
      step("查询与选择", "可按关键词或 SPU 编号搜索，打开现有记录编辑，或点击新增创建主款。"),
      step("维护主信息", "选择商品分类、品牌和工厂，填写名称、规格、图片及描述；分类会影响商品编码及后续 SKU 属性。"),
      step("批量导入图片", "点击列表上方批量导入图片，选择款号或自定义款号命名的图片（如Z00001_01.jpg）。核对自动分组，为待指定图片选择SPU后开始导入。新图追加保留旧图，本次序号最小的新图作为展示图；失败项可重试或下载清单。"),
      step("保存或删除", "确认主信息后保存；删除前先核对是否已经存在关联 SKU 或业务单据。")
    ],
    ["SPU 是 SKU 的上级主数据，修改分类和规格可能影响后续建款。", "仍被 SKU 或业务数据使用的 SPU 不应删除。"]
  ),
  "sku-list": doc(
    "SKU、报价与组合关系管理",
    "维护可参与库存业务的具体款式，并管理供应商报价、费用和组合关系。",
    ["查询 SKU", "新增或编辑", "维护属性和费用", "保存", "维护报价或组合", "启用"],
    [
      step("维护基础资料", "选择所属 SPU，填写基础、尺寸、镶嵌物、供应链和标准费用信息；工厂交期、入库周期应为非负整数。"),
      step("保存后维护扩展数据", "先保存 SKU，再维护供应商报价或组合关系。报价需选择供应商并填写价格；组合仅适用于主件、配件且数量必须大于零。"),
      step("启停管理", "新建 SKU 默认停用，可在列表单条或批量上架、下架。")
    ],
    ["SKU 启停会影响后续库存选货。", "批量操作前请核对选择范围，避免误停用正常款式。"]
  ),
  "bill-list": context => {
    const mode = context.mode || "normal";
    const titles = { normal: "出库单管理", transfer: "调拨单管理", borrow: "借货单管理" };
    const action = mode === "transfer" ? "发起跨公司调拨或公司内部调拨" : mode === "borrow" ? "新建借货申请并跟踪归还" : "新建普通出库";
    return doc(
      titles[mode] || titles.normal,
      `查询和管理${titles[mode] || titles.normal}，并按当前模式提供对应的新建、查看和导出操作。`,
      ["设置筛选条件", "查询单据", action, "查看或继续处理"],
      [
        step("筛选单据", "可按关键词、公司、渠道、单据日期、业务类型及状态筛选，清空条件后可恢复完整列表。"),
        step("办理业务", mode === "transfer" ? "可进入跨公司调拨，或使用公司内部调拨入口。" : mode === "borrow" ? "可新建借货申请、打开借货详情继续确认或归还，并导出借货数据。" : "点击操作出库进入新增出库页面。"),
        step("查看结果", "通过行操作打开单据详情，按页面权限执行打印、导出或后续处理。")
      ],
      ["路由中的业务模式会限制可见按钮和单据范围。", "导出前请确认筛选条件，避免导出范围过大。"]
    );
  },
  "inbound-list": doc(
    "入库单管理",
    "查询待审核、已审核和已取消入库单，并进入新增、审核、查看和导出流程。",
    ["筛选入库单", "新增或打开待审核单", "审核、取消或查看", "导出"],
    [
      step("筛选与新建", "按关键词、公司、日期、入库类型和状态筛选；点击操作入库创建待审核入库单。"),
      step("处理待审核单", "打开待审核单核对明细并审核；只有待审核记录允许删除或取消。"),
      step("查看与导出", "已审核或已取消记录以查看为主，可按当前筛选条件导出。")
    ],
    ["跨公司调拨接收应从跨公司调拨页面处理。", "待审核单尚未形成正式库存。"]
  ),
  "inbound-create": doc(
    "新增入库",
    "通过手工、扫码或 Excel 导入形成待审核入库单。",
    ["选择录入方式", "选择公司和类型", "添加或导入明细", "核对数据", "保存待审核单", "入库审核"],
    [
      step("选择录入方式", "可手工填写、扫描货品批次，或下载最新模板并上传单个 Excel 文件。"),
      step("维护入库明细", "核对批次号、系统款号、库房、渠道、数量、重量和金重；涉及金重时同时核对金价、工费和计价字段。"),
      step("核对价格与税额", "采购价、销售价及含税、不含税金额必须满足页面校验，避免后续成本不一致。"),
      step("保存并审核", "保存后生成待审核入库单，还需进入入库审核页面完成审核。")
    ],
    ["Excel 必须使用页面提供的最新模板。", "保存待审核单不等于正式入库，审核通过后才增加库存。"]
  ),
  "inbound-audit": doc(
    "入库审核",
    "核对待审核入库明细，通过扫描或勾选完成正式入库。",
    ["打开待审核单", "核对或修正明细", "扫描或批量审核", "查看已审核结果", "打印"],
    [
      step("核对单据", "检查公司、类型、单号、库房、渠道和待审核明细，必要时在允许范围内修正。"),
      step("执行审核", "扫描审核需填写批次并保证数量一致；批量审核或取消审核只处理当前选择的待审核明细。"),
      step("确认结果", "审核成功后在已审核页签查看结果，并按需打印预入库单或入库接收单。")
    ],
    ["只有审核成功的明细才进入正式库存。", "批量处理前核对勾选范围和数量。"]
  ),
  "outbound-create": doc(
    "新增出库",
    "通过查询、扫码或 Excel 导入选择现有库存并生成出库单。",
    ["选择录入方式", "选择公司和出库类型", "查询或导入库存", "核对数量和批次", "保存出库单"],
    [
      step("选择公司和类型", "先确认出库所属公司及业务类型，再选择手工查询、扫码或 Excel 导入。"),
      step("添加出库明细", "按批次、系统款号等条件查询库存；同一库存明细不要重复添加。"),
      step("核对并保存", "确认库房、渠道、批次、数量和价格，出库数量必须大于零且不超过可用数，然后保存出库单。")
    ],
    ["Excel 操作必须使用页面提供的最新模板。", "保存前再次确认公司、仓库、渠道和批次，避免从错误库存出库。"]
  ),
  "bill-detail": context => doc(
    context.type === "in" ? "入库单详情" : "出库单详情",
    "查看单据头、来源信息、金额和库存明细，并按需打印。",
    ["打开单据", "核对基础信息", "查看明细和金额", "打印或返回"],
    [
      step("查看单据头", "核对公司、业务类型、单号、库房、渠道、关联单号、日期及经办人员。"),
      step("查看明细", `明细数量和金额按${context.type === "in" ? "入库" : "出库"}方向展示，同时可核对批次、款式和来源。`),
      step("打印或返回", "确认信息后可打印通知单，或返回来源列表。")
    ],
    ["本页以查看和打印为主，不提供直接库存调整。"]
  ),
  "cross-transfer": doc(
    "跨公司调拨",
    "由来源公司发起调拨，接收公司逐条接收或拒收后完成两端库存处理。",
    ["来源公司发起", "生成来源单号", "接收公司打开", "逐条接收或拒收", "保存提交", "完成两端出入库"],
    [
      step("发起调拨", "选择不同的来源公司和接收公司，添加来源库存并确认调拨数量不超过可用数。"),
      step("接收处理", "接收公司按来源单号打开，每条明细选择接收或拒收，并核对实际批次和数量。"),
      step("提交结果", "所有明细都有处理结果后保存，系统按接收结果完成来源出库和接收入库。")
    ],
    ["来源公司和接收公司不能相同。", "拒收货品不会进入接收公司库存。"]
  ),
  borrow: doc(
    "借货申请、确认与归还",
    "管理借货申请、负责人审核、实际批次确认、借出和分批归还。",
    ["填写借货申请", "添加预借库存", "负责人审核", "扫描确认实际批次", "确认借出", "分批或全部归还"],
    [
      step("创建申请", "填写所属公司、申请日期、预计归还日期和借货原因，添加库存并保证预借数量不超过可用数。"),
      step("审核与确认借出", "负责人审核后，由供应链扫描或确认实际批次；实际批次可替换预借批次，确认借出后正式扣减库存。"),
      step("办理归还", "选择或扫描已借货品，填写本次归还数量；可分批归还，数量不得超过剩余待还数。")
    ],
    ["确认借出前请核对实际扫描批次。", "归还数量不得超过剩余待还数量。"]
  ),
  "pending-list": context => {
    const names = { repair: "维修", gold: "融金", tolling: "送料加工" };
    const prefix = names[context.template] ? `${names[context.template]}待回货` : "待回货";
    return doc(
      `${prefix}管理`,
      "查询维修、融金和送料加工申请及自动生成的待回货单，并进入新增、审核、回货和查看流程。",
      ["选择流程及结案方式", "筛选单据", "新建申请或去处理", "查看状态", "导出"],
      [
        step("筛选业务", "按关键词、流程类型、结案方式、公司、日期和状态筛选；路由入口会默认选中对应流程。"),
        step("新建或继续处理", "从对应入口新建维修、融金或送料加工申请；列表中的去处理会打开当前业务阶段，完成后改为查看。"),
        step("取消与导出", "库管审核出库前，具备权限的人员可填写原因取消申请；导出前确认当前筛选及导出范围。")
      ],
      ["取消单条出库明细时至少保留一条有效明细；全部取消应使用取消申请。", "待回货完成后是否还需普通入库审核，以结案方式和流程类型为准。"]
    );
  },
  "assembly-list": doc(
    "组装拆分单管理",
    "查询组装、拆分单据并进入新建、审核、详情或删除操作。",
    ["筛选单据", "新建组装或拆分", "提交或继续审核", "查看完成结果"],
    [
      step("筛选与识别", "按关键词、公司、日期、类型和状态筛选，并区分组装单、拆分单及完成记录。"),
      step("办理业务", "从工具栏新建组装或拆分；待处理记录可继续审核，完成记录可查看组装明细。"),
      step("删除待处理单", "只有页面允许的待处理记录可删除，删除前确认不再继续该业务。")
    ],
    ["组装和拆分的库存影响方向相反，打开单据前先核对类型。"]
  ),
  "assembly-detail": doc(
    "组装申请与审核",
    "将多条半成品库存组合为成品，并通过审核完成原料出库和成品入库。",
    ["选择半成品", "核对数量和成本", "选择成品 SKU", "填写成品入库", "提交审核", "审核入库"],
    [
      step("选择来源货品", "从半成品库存选择不少于两条来源明细，数量必须大于零且不超过库存；来源渠道应保持一致。"),
      step("维护成品", "核对来源成本，选择成品 SKU，填写成品批次、仓库、渠道、数量、重量和价格。"),
      step("提交及审核", "新增时提交审核；再次打开待审核单核对后执行审核入库，审核后才实际扣减原料并增加成品。")
    ],
    ["选择来源明细后公司会被锁定。", "审核前应核对成品成本与来源成本汇总。"]
  ),
  "assembly-split": doc(
    "组装拆分",
    "将已完成的组装成品按原材料映射拆回，并通过审核完成库存处理。",
    ["打开完成组装单", "生成拆分单", "核对成品和原料映射", "提交", "审核入库"],
    [
      step("选择来源组装单", "只有已完成组装业务允许创建拆分，系统按原组装关系带出成品和材料。"),
      step("核对方向", "确认正负明细、数量、批次和仓库，避免把成品与返还材料方向理解相反。"),
      step("提交审核", "提交生成待审核拆分单，只有待审核状态可以继续审核入库。")
    ],
    ["拆分必须以原组装数据为依据。", "完成审核后库存才正式变化。"]
  ),
  "check-list": doc(
    "盘点单管理",
    "发起库存盘点，跟踪进行中、暂停、完成和取消状态，并查看或导出结果。",
    ["筛选盘点单", "发起盘点", "进入盘点操作", "暂停、继续或完成", "查看及导出"],
    [
      step("查询或发起", "按关键词和公司筛选历史盘点，或创建新的盘点单。"),
      step("跟踪状态", "进行中可继续录入，暂停后可恢复，完成或取消记录以查看为主。"),
      step("查看与导出", "打开单据查看盘点结果；按页面要求选中记录后导出。")
    ],
    ["导出前确认已选择目标盘点单。", "同一范围存在进行中盘点时，应避免重复发起。"]
  ),
  "stock-check": doc(
    "库存盘点操作",
    "通过扫描、手工或批量方式记录实盘数，处理差异并完成盘点。",
    ["创建并选择公司", "扫描或录入盘点数", "查看已盘与未盘", "修正差异", "保存进度", "完成或取消"],
    [
      step("录入实盘数", "可扫描、按关键词手工录入数量和备注，或勾选后批量处理；微信扫描仅在支持的环境使用。"),
      step("核对盘点范围", "切换已盘和未盘明细，修正数量与备注，检查差异原因和处理结果。"),
      step("保存与结束", "可保存进度、暂停后继续；完成前确认没有遗漏，完成后不再允许继续修改。")
    ],
    ["差异原因、责任和处理说明应真实完整。", "完成盘点前重点核对未盘货品。"]
  ),
  "check-detail": doc(
    "历史盘点详情",
    "查看历史盘点汇总、已盘明细和剩余未盘明细。",
    ["打开盘点单", "查看汇总", "切换已盘与未盘", "查看或有限修正"],
    [
      step("查看汇总", "核对盘点单号、公司、状态和盘点统计。"),
      step("检查明细", "分别查看已盘和剩余未盘货品，核对数量、差异和备注。")
    ],
    ["本页为历史兼容页面，以查看和有限修正为主。"]
  ),
  "channel-stock": doc(
    "渠道库存",
    "查询当前或历史渠道库存，并在公司内部办理库房、渠道之间的调拨。",
    ["筛选库存", "查看或导出", "打开渠道调拨", "选择来源和目标", "填写数量并提交"],
    [
      step("查询库存", "按关键词、SKU 及当前或历史模式筛选，并按当前条件导出。"),
      step("创建渠道调拨", "选择公司、目标库房和渠道，添加 SKU 后选择来源库房、来源渠道并填写调拨数量。"),
      step("校验并提交", "来源与目标不能相同，数量必须大于零且不超过来源结余，同一来源库存不可重复添加。")
    ],
    ["渠道调拨只适用于页面允许的公司内部库存移动。"]
  ),
  "bound-list": context => {
    const mode = String(context.dynamic || "1");
    const titles = { "1": "当前库存", "0": "出库流水", "2": "入库流水", "3": "借货待还" };
    return doc(
      `${titles[mode] || "库存明细"}查询`,
      "按单据、日期、款式、批次、序列号和组织查询正式库存及出入库流水。",
      ["选择查询模式", "设置筛选条件", "查看来源和明细", "必要时修正", "导出"],
      [
        step("筛选库存", "按单号、日期、SKU、批次、品牌批次、序列号、公司、库房和渠道等条件查询。"),
        step("查看与维护", "可跳转来源单或库存详情；具备权限时可单条修正允许编辑的库存资料，或使用批量修改。"),
        step("导出", "按当前模式和筛选条件导出；当前库存导出必须明确选择一个公司。")
      ],
      ["修改税价字段时必须满足页面金额校验。", "流水记录用于追溯，不应当作当前可用库存。"]
    );
  },
  "outbound-tracking": doc(
    "外发货品跟踪",
    "基于正式出入库、临时明细和库存单据，查询维修、借货、送料加工和融金外发后的业务完结与库存入账状态。",
    ["选择外发跟踪页签", "筛选未完结或历史数据", "核对业务完结与库存状态", "追溯来源单", "导出"],
    [
      step("筛选外发货品", "可按关键词、批次号、系统款号、品牌款号、业务类型、结案方式、业务完结状态、库存状态、公司和正式出库日期查询。"),
      step("理解跟踪粒度", "维修和借货支持三表内可可靠计算的明细数量；送料加工和融金按整单跟踪，无法逐行对应的数量显示为横线。"),
      step("追溯业务", "从行操作打开原业务单、正式出库流水或关联入库单；本页不直接办理回货或结案。"),
      step("导出", "导出结果使用与当前列表完全相同的筛选和状态口径。")
    ],
    ["本页按当前流程专用单号前缀识别数据：维修 DHH-WX、融金 DHH-RJ、送料加工 DHH-SLJG、借货 JH；仅纳入 2026-01-01 及之后的正式出库，其他前缀及更早历史数据不会进入跟踪。", "业务已完结不代表库存已经正式入账，请同时核对库存状态。", "页面不再展示维修批次、送料加工计划差异、加工商或专项逾期等流程扩展状态。"]
  ),
  "bound-detail": doc(
    "库存明细",
    "查看库存批次、款式、数量、重量、成本、售价、仓库、渠道和来源单。",
    ["打开库存明细", "核对货品和批次", "查看金额及来源", "打印或返回"],
    [
      step("核对库存", "检查系统款号、品牌款号、批次、数量、重量、金重、仓库和渠道。"),
      step("查看价值和来源", "核对成本、售价及关联单据，必要时打印留档。")
    ],
    ["本页不直接修改库存，调整应从有权限的库存管理入口办理。"]
  ),
  "bound-temp": doc(
    "临时及待审核库存",
    "查询入库审核前的临时记录，跟踪待审核、已审核和已取消状态。",
    ["设置筛选条件", "查询临时记录", "查看来源单", "导出"],
    [
      step("查询记录", "按单据、公司、日期、款式和状态筛选临时入库信息。"),
      step("追溯来源", "通过来源单查看业务上下文，并按当前条件导出。")
    ],
    ["临时记录在审核完成前不属于正式库存。"]
  ),
  "material-list": doc(
    "金料单管理",
    "管理金料采购、工厂送料和工厂回货单据，并按状态进入查看或后续处理。",
    ["筛选金料单", "选择业务入口", "填写并保存", "财务确认或归档", "查看"],
    [
      step("筛选单据", "按关键词、公司、日期、操作类型和状态查询。状态包括待确认、已入库、已送料、已归档和已取消。"),
      step("新建业务", "按实际业务进入金料采购、工厂送料或工厂回货表单。"),
      step("查看或删除", "打开记录查看详情；只有待确认记录允许删除。")
    ],
    ["页面上的金料调整入口当前没有有效路由，不在本帮助中描述。"]
  ),
  "material-stores": doc(
    "金料库存与流水",
    "查看金料最新结余、历史流水以及待审核或已审核损耗记录。",
    ["选择公司和范围", "设置日期及类型", "切换结余或损耗状态", "查看来源", "导出"],
    [
      step("设置查询条件", "按公司、部门、工厂、日期、类型、是否最新和损耗状态筛选。"),
      step("识别数据含义", "最新结余用于查看当前余额，历史流水用于追溯变化，损耗记录按待审核和已审核区分。"),
      step("追溯与导出", "打开来源单核对业务原因，或按当前条件导出。")
    ],
    ["历史流水不等同于当前可用金料结余。"]
  ),
  "material-stored": doc(
    "金料采购单",
    "登记金料采购及部门分配，保存入库后由财务确认并归档。",
    ["选择公司和部门", "关联付款或填写采购信息", "填写材质、重量和单价", "分配部门", "保存入库", "财务确认归档"],
    [
      step("填写采购信息", "选择公司、采购部门，可关联付款单或直接填写材质、总重量和当日单价。"),
      step("分配部门明细", "每条部门数量必须大于零，明细合计应等于采购总重量；关联付款时金额必须一致。"),
      step("保存与归档", "保存后形成入库记录，再由财务确认并进入归档状态。")
    ],
    ["财务确认后不应继续修改基础数据。", "保存前核对付款金额、重量和部门合计。"]
  ),
  "material-dispatched": doc(
    "工厂送料单",
    "从本地金料库存向指定工厂和渠道送料，并处理可能产生的盈亏记录。",
    ["选择公司和材质", "添加工厂及渠道明细", "核对本地结余", "确认送料", "处理盈亏", "财务确认归档"],
    [
      step("添加送料明细", "选择目标工厂、渠道和送料重量，来源为本地金料仓库。"),
      step("核对并确认", "送料数量不得超过本地可用结余，确认后会扣减本地并形成工厂结余。"),
      step("处理后续记录", "如系统生成自动盈亏记录，应按页面状态完成审核，再由财务确认归档。")
    ],
    ["自动生成的盈亏记录不能忽略。", "确认送料前核对工厂、渠道和材质。"]
  ),
  "material-received": doc(
    "工厂回货单",
    "登记工厂回货成品，并同步形成成品入库信息和金料流水。",
    ["选择公司", "上传或维护回货成品", "匹配部门和工厂", "核对金重及费用", "保存", "补充单价", "财务确认归档"],
    [
      step("导入回货成品", "使用最新模板上传，或维护回货明细；品牌款号、批次号、部门和工厂信息必须完整。"),
      step("核对双向记录", "检查成品数量、金重、加工费用及金料记录，必要时关联入库信息。"),
      step("保存和确认", "保存时如系统要求当日单价，补充后重新提交；再由财务确认归档。")
    ],
    ["保存可能同时形成成品入库和金料流水，请核对两个页签。"]
  ),
  "purchase-list": doc(
    "采购与金料单列表",
    "按兼容入口现有能力查询、查看和删除采购或金料单据。",
    ["设置筛选条件", "查询单据", "进入可用的新建入口", "查看或删除"],
    [
      step("筛选单据", "按关键词、公司、日期、类型和状态查询，区分待确认、已审核和已归档记录。"),
      step("查看或删除", "通过行操作查看详情；仅待确认记录允许删除，已审核或归档记录只能查看。")
    ],
    ["本页属于兼容入口，实际可用的新建功能以当前路由和账号权限为准。"]
  ),
  "purchase-detail": doc(
    "采购申请单",
    "上传采购需求表生成回货成品明细，匹配组织及工厂信息后保存。",
    ["选择所属公司", "下载并填写模板", "上传 Excel", "匹配部门和工厂", "核对款号、批次和费用", "保存"],
    [
      step("准备并上传", "先选择所属公司，下载采购需求表模板并按列填写，再上传单个 Excel 文件。"),
      step("核对导入结果", "系统只保留具有品牌款号和金重的有效行；逐条确认款号、批次号、部门、工厂、数量、金重和加工费用。"),
      step("保存", "每条明细必须具有款号、批次、部门和工厂；如系统要求当日金价，补充单价后重新提交。")
    ],
    ["保存后应查看生成的金料记录。", "导入后仍需人工复核部门和工厂匹配结果。"]
  ),
  "out-order-list": doc(
    "外加工订单管理",
    "查询外加工订单，并按权限新增、编辑、查看或删除。",
    ["查询订单", "新增或编辑", "保存", "查看或删除"],
    [
      step("查询与选择", "按关键词搜索订单，点击新增创建，或从行操作打开现有订单编辑。"),
      step("删除", "选择目标订单后执行删除，删除前确认订单尚未进入不可撤销的后续业务。")
    ],
    ["可见按钮和可编辑范围受账号权限及订单状态影响。"]
  ),
  "out-order-detail": doc(
    "外加工订单",
    "登记外加工订单的业务类型、渠道、SKU、工厂、数量、交期和预计金额。",
    ["选择类型和渠道", "选择 SKU", "填写工厂及外部信息", "填写数量、交期和金额", "保存", "查看流程"],
    [
      step("填写订单头", "选择单据类型、下单渠道和日期，选择 SKU 后系统会自动带出部分商品资料。"),
      step("补充业务信息", "填写外部单号、工厂、品牌参考、预计日期、数量和预计金额。"),
      step("保存并查看", "提交前核对数量、工厂和交期；保存后可查看现有流程信息。")
    ],
    ["当前审批页签仍处于开发中，本页不提供未实现的审批能力。"]
  ),
  "tax-ticket": doc(
    "发票脚本生成",
    "将模板中的开票数据转换为脚本文本，供人工复核和后续使用。",
    ["下载模板", "填写开票数据", "上传单个 Excel", "查看生成结果", "人工复核并复制"],
    [
      step("准备文件", "下载页面提供的最新模板，严格按列填写纳税主体、金额、税额及明细。"),
      step("生成脚本", "上传单个 Excel，等待系统在文本框中返回生成结果。"),
      step("人工复核", "逐项核对主体、金额、税额和明细后，再复制到获准的后续流程。")
    ],
    ["上传只生成脚本文本，不代表已经开票或执行数据库操作。", "禁止直接使用未经复核的生成结果。"]
  ),
  "sell-report": doc(
    "销售统计",
    "按款式、组织、库房和日期查看销售、退货及规格占比图表。",
    ["设置筛选条件", "点击确认", "切换统计页签", "查看图表和表格"],
    [
      step("选择统计范围", "选择关键词、库房、公司、部门和日期后点击确认刷新。"),
      step("分析结果", "切换销售排名、销售占比、退货占比和规格占比；图表及表格均使用当前筛选条件。")
    ],
    ["本页只读，不会修改库存。", "跨页签比较时应保持筛选条件一致。"]
  ),
  "bound-day": doc(
    "历史库存报表",
    "按指定日期查询库存快照，用于回溯历史结余并导出。",
    ["设置关键词和组织", "选择库存日期", "查询历史快照", "查看或导出"],
    [
      step("选择查询范围", "设置关键词、公司、部门、仓库和库存日期，系统按指定日期返回快照。"),
      step("查看与导出", "核对历史数量及金额，并按当前条件导出；跨日期比较时保持其他筛选条件一致。")
    ],
    ["历史库存快照不等同于当前可用库存。"]
  )
};

export const stockHelpKeys = Object.keys(documents);

export function resolveStockHelpDocument(helpKey, context = {}) {
  const entry = documents[helpKey];
  if (!entry) {
    return doc(
      "库存管理",
      "当前页面的操作说明尚未配置。",
      [],
      [step("联系管理员", `请提供帮助标识“${helpKey}”，由管理员补充页面操作文档。`)],
      []
    );
  }
  return typeof entry === "function" ? entry(context) : entry;
}
